// we use custom heading size for hero banner

"use client";

import { Box, Flex, Heading } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";

import BannerSwiper from "./BannerSwiper";
import Image from "next/image";
import RewardsButton from "ui/rewards/RewardsButton";
import SearchBar from "ui/snippets/searchBar/SearchBarDesktop";
import SearchBarMobile from "ui/snippets/searchBar/SearchBarMobile";
import UserProfileDesktop from "ui/snippets/user/profile/UserProfileDesktop";
import UserWalletDesktop from "ui/snippets/user/wallet/UserWalletDesktop";
import config from "configs/app";

// import AdBanner from "ui/shared/ad/AdBanner";

interface bannerType {
  desktop: string;
  mobile: string;
  link: string;
  index: string;
}

export const banners = [
  {
    desktop: "/assets/my-dot-explorer-Mydot-desktop.jpg",
    mobile: "/assets/my-dot-explorer-Mydot-Mobile.jpg",
    link: "https://dotone.online",
    index: "0",
  },
  {
    desktop: "/assets/my-dot-explorer-Cell-banner-Desktop.jpg",
    mobile: "/assets/my-dot-explorer-Cell-banner-Mobile.jpg",
    link: "https://dotonecell.ir",
    index: "1",
  },
  {
    desktop: "/assets/Bitbank_Banner.png",
    mobile: "/assets/Bitbank_Banner.png",
    link: "https://bit3.ir/",
    index: "2",
  },
];

export const BACKGROUND_DEFAULT = "linear-gradient(to right, #F5BC27, #302B1E)";
const TEXT_COLOR_DEFAULT = "white";
const BORDER_DEFAULT = "none";

const HeroBanner = () => {
  const background = {
    _light:
      "linear-gradient(112deg, #365C74 0%, #506C7A 38%, #81785D 72%, #B58A35 100%)",
    _dark:
      config.UI.homepage.heroBanner?.background?.[1] ||
      config.UI.homepage.heroBanner?.background?.[0] ||
      BACKGROUND_DEFAULT,
  };

  const textColor = {
    _light:
      // light mode
      config.UI.homepage.heroBanner?.text_color?.[0] || TEXT_COLOR_DEFAULT,
    // dark mode
    _dark:
      config.UI.homepage.heroBanner?.text_color?.[1] ||
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      TEXT_COLOR_DEFAULT,
  };

  const border = {
    _light: config.UI.homepage.heroBanner?.border?.[0] || BORDER_DEFAULT,
    _dark:
      config.UI.homepage.heroBanner?.border?.[1] ||
      config.UI.homepage.heroBanner?.border?.[0] ||
      BORDER_DEFAULT,
  };

  const [currentBanner, setCurrentBanner] = useState<bannerType | null>(null);

  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (typeof window === "undefined") return;

    const stored = localStorage.getItem("heroBannerIndex");
    const currentIndex = stored ? Number(stored) : 0;

    const nextIndex = (currentIndex + 1) % banners.length;
    localStorage.setItem("heroBannerIndex", String(nextIndex));

    setCurrentBanner(banners[currentIndex]);
  }, []);

  if (!currentBanner) return null;

  return (
    <Flex
      w="100%"
      borderRadius="md"
      columnGap={4}
      rowGap={4}
      alignItems="stretch"
      flexDirection={{ base: "column", lg: "row" }}
      mt={4}
    >
      {/* Box 1: Search */}
      <Box
        flex="1"
        background={background}
        border={border}
        flexBasis="50%"
        borderRadius="md"
        p={{ base: 4, lg: 8 }}
      >
        <Flex
          mb={{ base: 2, lg: 3 }}
          justifyContent="space-between"
          alignItems="center"
          columnGap={2}
        >
          <Heading
            as="h1"
            fontSize={{ base: "18px", lg: "30px" }}
            lineHeight={{ base: "24px", lg: "36px" }}
            fontWeight={{ base: 500, lg: 700 }}
            color={textColor}
          >
            {config.meta.seo.enhancedDataEnabled
              ? `${config.chain.name} blockchain explorer`
              : `${config.chain.name} explorer`}
          </Heading>
          {config.UI.navigation.layout === "vertical" && (
            <Box display={{ base: "none", lg: "flex" }} gap={2}>
              {config.features.rewards.isEnabled && (
                <RewardsButton variant="hero" />
              )}
              {(config.features.account.isEnabled && (
                <UserProfileDesktop buttonVariant="hero" />
              )) ||
                (config.features.blockchainInteraction.isEnabled && (
                  <UserWalletDesktop buttonVariant="hero" />
                ))}
            </Box>
          )}
        </Flex>
        <Box display={{ base: "flex", lg: "none" }}>
          <SearchBarMobile isHeroBanner />
        </Box>
        <Box display={{ base: "none", lg: "flex" }}>
          <SearchBar isHeroBanner />
        </Box>
      </Box>

      {/* Box 2: Ad Banner with background image */}
      <Box
        flex="1"
        borderRadius="md"
        overflow="hidden"
        flexBasis="50%"
        position="relative"
        minH={{ lg: "100%" }}
      >
        <BannerSwiper banners={banners} />
      </Box>
    </Flex>
  );
};

export default React.memo(HeroBanner);
